if (!customElements.get('paula-size-guide')) {
  customElements.define('paula-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.unitListener) return;
      this.unitListener = (event) => {
        const button = event.target.closest('[data-unit-button]');
        if (!button || !this.contains(button)) return;
        const unit = button.dataset.unitButton;
        if (unit !== 'cm' && unit !== 'in') return;
        this.dataset.unit = unit;
        this.querySelectorAll('[data-cm][data-in]').forEach((value) => {
          value.textContent = value.dataset[unit];
        });
        this.querySelectorAll('[data-unit-button]').forEach((control) => {
          control.setAttribute('aria-pressed', String(control.dataset.unitButton === unit));
        });
      };
      this.addEventListener('click', this.unitListener);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.unitListener);
      this.unitListener = null;
    }
  });
}
